import { SecurityOidcService } from '../../core/services/system/security.oidc.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { SJIService } from '../../services/sji.service';
import { WEB_API_URLS } from '../../_configs/webapiurls';
import { AppContextService } from '../../services/sji.appcontext.service';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  companyList: any[] = [{ key: '', value: '' }];

  /**Control */
  userName = '';
  roleName=''; //value = 'SysAdmin' or 'CompanyAdmin' field "Code" in table dbo.[Role].
  isLogin = false;
  companyId: number = 0;
  isLogOutDialog: boolean = false;
  dialogScreen: boolean = false;
  item_class1_Stretch: string = null;
  item_class1: string = null;
  item_class2: string = null;
  item_class3: string = null;
  isStretch: boolean = false;
  routerStrList: any[] = [
    { name: 'home', index: '1' },
    { name: 'user', index: '2' },
    { name: 'company', index: '3' },
    { name: 'customer', index: '4' },
    { name: 'order', index: '5' },
    { name: 'tracking', index: '6' }
  ];
  imgStr:string='/assets/images/SailunAdminLogo.png';

  constructor(
    private securityService: SecurityOidcService,
    public sJIService: SJIService,
    private sJIAppContextService: AppContextService,
    private router: Router
  ) {
    const info = this.securityService.getClaims();
    if (info) {
      this.userName = info.name; 
      this.roleName=info.role; // value = 'SysAdmin' or 'CompanyAdmin'
      this.sJIService.userName = info.name; 
      this.isLogin = true;
    } else {
      this.userName = ''; this.isLogin = false;
      this.sJIService.userName = '';
    }
    this.initPars();
  }

  initPars() {
    this.initCompanyList();
    this.setActiveHeader();
  }

  // ngAfterViewChecked() {
  //   this.setParamsStr();
  // }

  /**Other */
  signout(e) {
    // Prevent from trigger form submit.
    e.preventDefault();
    this.securityService.signout();
  }

  signin(e) {
    e.preventDefault();
    this.securityService.login();
  }

  /** Interactive.  Change company from the drop down on Top Menu.*/
  public valueChange_companyList(value) {
    if (value > 0) {
      console.log('valueChange_companyList: companyId=' + value);
      
      // Set company id
      if (!this.sJIService.isEmpty(value)) {
        this.companyId = parseInt(value);
        this.sJIService.currentCompanyId = value;
      }
      this.sJIAppContextService.setCompanyId(value);
    } else {
      this.router.navigate(['home']);
      this.click_signSecond('1','1');
    }
    // TODO. Need to change to corporate with companyChanged event emiter.
    // window.location.reload();
  }

  //1:go upcomingPromoos  2:go activePromos  3:go expiredPromos
  public routerPromos(routerType: number, index: string, activeIndex: string) {
    let data = { routerType };
    this.router.navigate(['order/newUpcomingPromos' + routerType], { queryParams: data });
    this.click_signThird(index,activeIndex);
  }

  // Side Promotion Bar pages: 1=Upcoming, 2=Active, 3=Expired
  public routerSidePromos(routerType: number, index: any, activeIndex: any) {
    const data = { routerType };
    this.router.navigate(['order/sidePromos' + routerType], { queryParams: data });
    this.click_signThird(index, activeIndex);
  }


  /**Api */
  private initCompanyList() {
    this.sJIService.get(WEB_API_URLS.common_company).subscribe(data => {
      if (this.sJIService.isEmpty(data)) { return; }
      this.companyList = data as any[];
      const addItem = [{ key: 0, value: 'All' }];
      this.companyList = addItem.concat(this.companyList);
      // Set company id
       const com_Id = this.sJIAppContextService.getCompanyId();
       if (!this.sJIService.isEmpty(com_Id)) {
          this.companyId = parseInt(com_Id);
          this.sJIService.currentCompanyId = this.companyId;
       }
    });
  }

  /**Control */
  public closeDialog_logOut() {
    this.isLogOutDialog = false;
    this.dialogScreen = false;
  }

  public openDialog_logOut() {
    this.isLogOutDialog = true;
    this.dialogScreen = true;
  }

  //first extension
  public click_signFirst(index) {
    if (window.innerWidth >= 601) return;
    if (!this.sJIService.isEmpty(this.item_class1) && this.item_class1 == index) {
      this.item_class1 = null;
      return;
    }
    this.item_class1 = index;
  }

  //Second  extension
  public click_signSecond(index: string, activeIndex: string) {
    if (!this.sJIService.isEmpty(activeIndex)) {
      this.item_class1 = activeIndex;
    }
    this.stopBubble();
    if (window.innerWidth <= 601) {
      if (!this.sJIService.isEmpty(this.item_class2) && this.item_class2 == index) {
        this.item_class2 = null;
        return;
      }
    }
    this.stopBubble();
    this.item_class2 = index;
  }

  //third extension
  public click_signThird(index: string, activeIndex: string) {
    if (!this.sJIService.isEmpty(activeIndex)) {
      this.item_class1 = activeIndex;
    }
    this.stopBubble();
    this.item_class3 = index;
  }

  public stopBubble() {
    if (window.event && window.event.stopPropagation)
      window.event.stopPropagation();
    else
      window.event.cancelBubble = true;
  }

  public showNav() {
    this.isStretch = !this.isStretch;
  }

  /**Private */
  private setActiveHeader() {
    let routeStr = window.location.pathname;
    if (this.sJIService.isEmpty(routeStr)) return;
    let str = routeStr.split('/')[1];
    let dataList = this.routerStrList.filter(item => {
      if (item.name == str) {
        return item;
      }
    });
    if (this.sJIService.isEmpty(dataList) && dataList.length <= 0) return;
    this.item_class1 = dataList[0].index;
  }

}
